import { countryCodes } from "./data";

const digitsOnly = (value) => String(value || "").replace(/\D/g, "");

// Resolves a country entry using ISO code first, then dialing code only when
// it uniquely identifies one country. For shared dialing codes such as +1
// (US/Canada/Caribbean), the ISO code is required — without it we fall back
// to the provided defaultCountryCode (or null) so the user must pick manually.
export function resolveCountry({
  iso,
  dialCode,
  defaultCode = "PK",
} = {}) {
  if (iso) {
    const byIso = countryCodes.find((c) => c.code === iso);
    if (byIso) return byIso;
  }

  const digits = digitsOnly(dialCode);
  if (digits) {
    const matches = countryCodes.filter((c) => digitsOnly(c.dialCode) === digits);
    if (matches.length === 1) return matches[0];
  }

  return defaultCode
    ? countryCodes.find((c) => c.code === defaultCode)
    : null;
}
